module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-R-18.55e9549f.png";